import { useParams } from "react-router-dom";

import { useQuery } from "@tanstack/react-query";

import { Plants } from "../../../api/plants";
import { QueryKey } from "../../../consts/query-keys";

export const useCostsData = (shouldFetchData: boolean) => {
  const { datasetId, id } = useParams();
  const { data: costsData, isPending } = useQuery({
    queryKey: [QueryKey.CostsSection, datasetId, id],
    queryFn: () =>
      Plants.getCosts({
        path: { datasetId: +datasetId! as number, plantId: +id! as number },
      }).then(response => {
        return response;
      }),
    throwOnError: true,
    enabled: shouldFetchData,
  });

  return { costsData, isPending };
};
